'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsharePublicBoard = exports.publiclyShareBoard = exports.removeSharedUser = exports.addSharedUser = exports.toggleShareForm = undefined;

var _permissionsService = require('../../../../utils/permissions/permissionsService');

var _permissionUtil = require('../../../../../common/permissions/permissionUtil');

var _userService = require('../../../../user/userService');

var _elementActions = require('../../../../element/elementActions');

var _sharingPopupConstants = require('./sharingPopupConstants');

var _errorConstants = require('../../../../../common/error/errorConstants');

var _validationConstants = require('../../../../../common/validation/validationConstants');

var _userConstants = require('../../../../../common/users/userConstants');

var _analytics = require('../../../../analytics');

var toggleShareForm = exports.toggleShareForm = function toggleShareForm() {
    return { type: _sharingPopupConstants.SHARE_POPUP_TOGGLE_SHARE_FORM };
};

// Constants


// Actions
// Util
var addSharedUser = exports.addSharedUser = function addSharedUser(_ref) {
    var elementId = _ref.elementId,
        userEmail = _ref.userEmail;
    return function (dispatch, getState) {
        var state = getState();
        var elements = state.get('elements');
        var lowerCaseUserEmail = userEmail.toLowerCase();

        return dispatch((0, _userService.getOrInviteUser)({ userEmail: lowerCaseUserEmail })).catch(function (err) {
            var error = err.response && err.response.data && err.response.data.error;

            // TODO I don't think this is used any more, so should be removed.  Also need server side validation
            // TODO    for sharing invites
            // On validation errors respond with a structure that the form can react to
            if (error && error.code === _errorConstants.USER_ERROR.NOT_FOUND) {
                var errorRes = {
                    userEmail: {
                        message: error.message,
                        type: _validationConstants.FAILURE_TYPES.ERROR,
                        value: lowerCaseUserEmail
                    }
                };
                return Promise.reject(errorRes);
            }
            return Promise.reject(err);
        }).then(function (user) {
            var elementPermissionsMap = (0, _permissionsService.getAllPermissions)(elements, elementId);
            if (elementPermissionsMap[user._id]) {
                return Promise.reject({
                    userEmail: {
                        message: 'This board has already been shared with ' + user.name.displayName,
                        type: _validationConstants.FAILURE_TYPES.WARNING,
                        value: lowerCaseUserEmail
                    }
                });
            }

            // Add the user to the element's permissions
            // Calculate the default permissions for a user
            var permissions = (0, _permissionUtil.calculatePermissionValue)({});

            dispatch((0, _elementActions.shareElement)({
                id: elementId,
                userId: user._id,
                permissions: permissions
            }));

            (0, _analytics.analyticsEvent)('shared-board', {
                invited_user_email: lowerCaseUserEmail,
                invited_user_status: user.status
            });

            return user;
        }).catch(function (err) {
            console.error('ERROR: Adding shared user.', err, err.response);
            return Promise.reject(err);
        });
    };
};

var removeSharedUser = exports.removeSharedUser = function removeSharedUser(_ref2) {
    var elementId = _ref2.elementId,
        userId = _ref2.userId;
    return function (dispatch, getState) {
        var state = getState();
        var elements = state.get('elements');

        var elementPermissionsMap = (0, _permissionsService.getAllPermissions)(elements, elementId);
        if (!elementPermissionsMap[userId]) {
            throw new Error({
                userId: {
                    message: 'This board is not shared with user ID \'' + userId + '\'',
                    type: _validationConstants.FAILURE_TYPES.WARNING,
                    value: userId
                }
            });
        }

        (0, _analytics.analyticsEvent)('unshared-board');

        return dispatch((0, _elementActions.unshareElement)({
            id: elementId,
            userId: userId
        }));
    };
};

var publiclyShareBoard = exports.publiclyShareBoard = function publiclyShareBoard(_ref3) {
    var elementId = _ref3.elementId;

    (0, _analytics.analyticsEvent)('shared-public-board');

    return (0, _elementActions.shareElement)({
        id: elementId,
        userId: _userConstants.PUBLIC_USER_ID,
        permissions: (0, _permissionUtil.calculatePermissionValue)({ read: true, write: false, save: false, permissions: false })
    });
};

var unsharePublicBoard = exports.unsharePublicBoard = function unsharePublicBoard(_ref4) {
    var elementId = _ref4.elementId;

    (0, _analytics.analyticsEvent)('unshared-public-board');

    return (0, _elementActions.unshareElement)({
        id: elementId,
        userId: _userConstants.PUBLIC_USER_ID
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/sharing/sharingPopupActions.js
// module id = 478
// module chunks = 0